// campaign
const Listcampaign = () => import('@/views/campaign-management/campaign')
const Formcampaign = () => import('@/views/campaign-management/campaign/form')
const Detailcampaign = () => import('@/views/campaign-management/campaign/detail')

export default {
    path: 'campaign',
    redirect: '/campaign',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'campaign',
            component: Listcampaign,
            meta: {
                link: 'campaign',
                breadcrumb: [
                    { title: 'Master', active: true },
                    { title: 'Campaign Management', active: true },
                ],
                pageTitle: 'Campaign'
            }
        },
        {
            path: 'add',
            name: 'addcampaign',
            component: Formcampaign,
            meta: {
                link: 'campaign',
                breadcrumb: [
                    { title: 'Master', active: true },
                    { title: 'Campaign Management', url: '/campaign' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Campaign'
            }
        },
        {
            path: 'edit/:id',
            name: 'editcampaign',
            component: Formcampaign,
            meta: {
                link: 'campaign',
                breadcrumb: [
                    { title: 'Master', active: true },
                    { title: 'Campaign Management', url: '/campaign' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Campaign'
            }
        },
        {
            path: ':id',
            name: 'detailcampaign',
            component: Detailcampaign,
            meta: {
                link: 'campaign',
                breadcrumb: [
                    { title: 'Master', active: true },
                    { title: 'Campaign Management', url: '/campaign' },
                    { title: 'Detail', active: true },
                ],
                pageTitle: 'Detail Campaign'
            }
        },
    ]
}